// First-touch attribution cookie for direct app visitors (KB-8753).
// Backend reads cdbl_src at signup (card BE-3). Website sets the same cookie for
// visitors who start there, so never overwrite an existing value: first touch wins.

export const SOURCE_COOKIE_NAME = 'cdbl_src'
const MAX_AGE_SECONDS = 90 * 24 * 60 * 60
const MAX_LENGTH = 500
const URL_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'ref']
const ENTRY_PATH = /^\/tasks\/new\/?$/

const hasCookie = (name) => {
  return document.cookie.split(';').some(c => c.trim().startsWith(`${name}=`))
}

const truncate = (value) => (value || '').slice(0, MAX_LENGTH)

export const buildSourceValue = (loc = window.location, referrer = document.referrer, now = new Date()) => {
  const params = new URLSearchParams()
  params.set('first_seen', now.toISOString())
  params.set('landing', truncate(`${loc.pathname}${loc.search}`))
  params.set('referrer', truncate(referrer))

  const query = new URLSearchParams(loc.search)
  URL_KEYS.forEach(key => {
    const value = query.get(key)
    if (value) {
      params.set(key, value)
    }
  })

  return params.toString()
}

// Only direct /tasks/new visitors get tagged here; everyone else is tagged by the website.
export const writeSourceCookie = (loc = window.location) => {
  try {
    if (!ENTRY_PATH.test(loc.pathname) || hasCookie(SOURCE_COOKIE_NAME)) {
      return false
    }

    const domain = loc.hostname.endsWith('codeable.io') ? '; Domain=.codeable.io' : ''
    const secure = loc.protocol === 'https:' ? '; Secure' : ''
    const value = encodeURIComponent(buildSourceValue(loc))

    document.cookie = `${SOURCE_COOKIE_NAME}=${value}; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax${domain}${secure}`
    return true
  } catch (err) {
    // Never let attribution break app boot
    return false
  }
}
